import { texts } from '../../chunk-A4OC4Y6M.mjs';
import '../../chunk-SBPTPVOR.mjs';
import { ErrorOutlined } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { jsx, jsxs } from 'react/jsx-runtime';

var ErrorFallback = (props) => {
  const { errorMessage = texts.message, canRetry = true } = props;
  return /* @__PURE__ */ jsx(
    Box,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        bgcolor: "background.default"
      },
      children: /* @__PURE__ */ jsx(Container, { maxWidth: "sm", children: /* @__PURE__ */ jsx(Card, { elevation: 12, children: /* @__PURE__ */ jsxs(CardContent, { sx: { textAlign: "center" }, children: [
        /* @__PURE__ */ jsx(
          ErrorOutlined,
          {
            color: "error",
            sx: {
              fontSize: 80,
              mb: 2
            }
          }
        ),
        /* @__PURE__ */ jsxs(
          Box,
          {
            sx: {
              textAlign: "center",
              py: 2
            },
            children: [
              /* @__PURE__ */ jsx(Typography, { variant: "h5", component: "h2", gutterBottom: true, children: texts.title }),
              /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "body2",
                  gutterBottom: true,
                  sx: {
                    color: "text.secondary"
                  },
                  children: errorMessage
                }
              ),
              canRetry && /* @__PURE__ */ jsx(
                Box,
                {
                  sx: {
                    mt: 3
                  },
                  children: /* @__PURE__ */ jsx(
                    Button,
                    {
                      variant: "contained",
                      fullWidth: true,
                      onClick: () => window.location.reload(),
                      children: texts.tryAgain
                    }
                  )
                }
              )
            ]
          }
        )
      ] }) }) })
    }
  );
};

export { ErrorFallback };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map